export default __webpack_public_path__ + "static/media/placeholder_portfolio04-es-web.fc5bcf94.png";